import React from 'react'
import TabContent from '../TabContent.component'
import Need1 from "../../assets/need-1.svg";
import thumbImg from '../../assets/SolutionsImage/vectorImages/Swayam CRM Sales/fdgdf (1).jpg'

let css = `
    .active-tab{
        color: #fff;
        background-color: #174997;
    }
    .active-tab img{
        filter: invert(1);
    }
`;

export default function SswayamERPSarvice() {
    return (
        <>
            <section className="">
                {/* SOLUTION FOR YOUR UNIQUE BUSINESS NEEDS */}
                <section>
                    <section>
                        <style>{css}</style>
                        <div className="flex mb-12 mt-0 max-w-[80%] justify-center mx-auto items-center">
                            <div
                                className=" p-5 max-h-[770px]  overflow-y-auto scroll-smooth"
                                // ref={scrollRef}
                            >
                                <TabContent
                                    index={0}
                                    icon={Need1}
                                    thumbnail={thumbImg}
                                    title={"Service"}
                                    content={[
                                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam sem enim, pharetra nec neque et, pulvinar ultrices purus. Curabitur egestas a ipsum eu accumsan. Vestibulum malesuada sed nulla et aliquam. Interdum et malesuada fames ac ante ipsum primis in faucibus. Integer viverra pretium mi et commodo."
                                    ]}
                                    captionWidth={"200px"}
                                />
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </>
    )
}
